<template>
    <svg version="1.1"
        width="300" height="200"
        xmlns="http://www.w3.org/2000/svg">

    <rect width="100%" height="100%" fill="red" />

    <circle cx="150" cy="100" r="80" fill="green" />

    <text x="150" y="125" font-size="60" text-anchor="middle" fill="white">SVG</text>

    </svg>
</template>

<script>
//https://developer.mozilla.org/en-US/docs/Web/SVG/Tutorial/Getting_Started
// https://dev.to/tqbit/how-to-create-svg-elements-with-javascript-4mmp
// https://www.weareteachers.com/virtual-rewards/
export default {

}
</script>

<style>

</style>
